/* ================================================================
   HOA PRODUCT PAGE — product-page.js
   Variant-Switching, Gallery, Quantity, Sticky ATC, Accordion.
   Vanilla JS. Integriert mit Cart Drawer aus Session 1.
   ================================================================ */
(function () {
  'use strict';

  /* Product JSON aus Liquid-Block */
  var productDataEl = document.getElementById('hoa-product-json');
  if (!productDataEl) return;

  var product  = JSON.parse(productDataEl.textContent);
  var variants = product.variants;

  /* ── DOM ──────────────────────────────────────────────────── */
  var atcBtn       = document.getElementById('hoa-pdp-atc');
  var stickyBtn    = document.getElementById('hoa-pdp-sticky-btn');
  var stickyBar    = document.getElementById('hoa-pdp-sticky');
  var stickyPrice  = document.getElementById('hoa-pdp-sticky-price');
  var variantInput = document.getElementById('hoa-pdp-variant-input');
  var mainImgEl    = document.getElementById('hoa-pdp-main-img-el');
  var thumbsEl     = document.getElementById('hoa-pdp-thumbs');
  var qtyInput     = document.getElementById('hoa-pdp-qty');
  var qtyMinus     = document.getElementById('hoa-pdp-qty-minus');
  var qtyPlus      = document.getElementById('hoa-pdp-qty-plus');

  /* ── State ────────────────────────────────────────────────── */
  var selectedOptions = [];
  var currentVariant  = null;

  /* ── Init ─────────────────────────────────────────────────── */
  function init() {
    /* Variante aus URL oder ersten verfügbaren */
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariantId = urlParams.get('variant');

    if (urlVariantId) {
      currentVariant = variants.find(function (v) { return String(v.id) === urlVariantId; });
    }
    if (!currentVariant) {
      currentVariant = variants.find(function (v) { return v.available; }) || variants[0];
    }

    selectedOptions = currentVariant ? currentVariant.options.slice() : [];

    refreshOptionButtons();
    updateUI(false); /* kein URL-Push beim ersten Render */

    bindOptionBtns();
    bindQty();
    bindThumbs();
    bindSwipe();
    bindAccordion();
    initStickyAtc();
  }

  /* ── Variant finden ───────────────────────────────────────── */
  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (val, idx) {
        return val === selectedOptions[idx];
      });
    }) || null;
  }

  /* ── UI aktualisieren ─────────────────────────────────────── */
  function updateUI(pushState) {
    if (!currentVariant) return;

    /* Preis */
    document.querySelectorAll('[data-pdp-price]').forEach(function (el) {
      el.textContent = formatMoney(currentVariant.price);
    });
    if (stickyPrice) stickyPrice.textContent = formatMoney(currentVariant.price);

    /* ATC-Buttons */
    var available = currentVariant.available;
    [atcBtn, stickyBtn].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !available;
      btn.textContent = available ? 'IN DEN WARENKORB' : 'AUSVERKAUFT';
      btn.setAttribute('data-variant-id', currentVariant.id);
    });

    /* Hidden input fürs Boundless-Formular */
    if (variantInput) variantInput.value = currentVariant.id;

    /* URL */
    if (pushState !== false) {
      window.history.replaceState(
        { variant: currentVariant.id },
        '',
        window.location.pathname + '?variant=' + currentVariant.id
      );
    }

    /* Bild wenn Variante ein eigenes Bild hat */
    if (currentVariant.featured_image && mainImgEl) {
      var raw = currentVariant.featured_image.src;
      /* Shopify-URL: _SIZE einfügen */
      var src800 = raw.replace(/(\.[a-z]{3,4})(\?.*)?$/, '_800x$1$2');
      mainImgEl.src  = src800;
      mainImgEl.alt  = currentVariant.featured_image.alt || product.title;
      highlightThumb(src800);
    }
  }

  /* ── Money Formatter ──────────────────────────────────────── */
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ── Option-Buttons ───────────────────────────────────────── */
  function bindOptionBtns() {
    document.querySelectorAll('.hoa-pdp__opt-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx   = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-option-value');
        selectedOptions[idx] = value;

        /* Label aktualisieren */
        var valLabel = document.getElementById('hoa-pdp-opt-val-' + idx);
        if (valLabel) valLabel.textContent = value;

        currentVariant = findVariant();
        refreshOptionButtons();
        updateUI(true);
      });
    });
  }

  function refreshOptionButtons() {
    document.querySelectorAll('.hoa-pdp__opt-btn').forEach(function (btn) {
      var idx   = parseInt(btn.getAttribute('data-option-index'), 10);
      var value = btn.getAttribute('data-option-value');
      var isSelected = selectedOptions[idx] === value;

      /* Verfügbarkeit prüfen (alle anderen Optionen konstant lassen) */
      var testOpts = selectedOptions.slice();
      testOpts[idx] = value;
      var matchVariant = variants.find(function (v) {
        return v.options.every(function (val, i) { return val === testOpts[i]; });
      });
      var isAvailable = matchVariant ? matchVariant.available : false;

      btn.classList.toggle('hoa-pdp__opt-btn--active', isSelected);
      btn.classList.toggle('hoa-pdp__opt-btn--soldout', !isAvailable);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  /* ── Menge ────────────────────────────────────────────────── */
  function bindQty() {
    if (!qtyInput || !qtyMinus || !qtyPlus) return;

    function syncQty() {
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyInput.value = qty;
      [atcBtn, stickyBtn].forEach(function (btn) {
        if (btn) btn.setAttribute('data-qty', qty);
      });
    }

    qtyMinus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      syncQty();
    });
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      syncQty();
    });
    qtyInput.addEventListener('change', syncQty);
  }

  /* ── Thumbnails ───────────────────────────────────────────── */
  function bindThumbs() {
    if (!thumbsEl) return;

    thumbsEl.querySelectorAll('.hoa-pdp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        swapMainImage(
          thumb.getAttribute('data-image-src'),
          thumb.getAttribute('data-image-alt')
        );
        setActiveThumb(thumb);
      });
    });
  }

  function swapMainImage(src, alt) {
    if (!mainImgEl || !src) return;
    mainImgEl.src = src;
    mainImgEl.alt = alt || '';
  }

  function setActiveThumb(activeThumb) {
    if (!thumbsEl) return;
    thumbsEl.querySelectorAll('.hoa-pdp__thumb').forEach(function (t) {
      t.classList.remove('hoa-pdp__thumb--active');
    });
    activeThumb.classList.add('hoa-pdp__thumb--active');
  }

  function highlightThumb(imgSrc) {
    if (!thumbsEl) return;
    thumbsEl.querySelectorAll('.hoa-pdp__thumb').forEach(function (thumb) {
      var thumbSrc = thumb.getAttribute('data-image-src') || '';
      /* Grober Vergleich: Shopify-ID im Dateinamen */
      var thumbBase = thumbSrc.split('_800x')[0].split('/').pop();
      var srcBase   = imgSrc.split('_800x')[0].split('/').pop();
      if (thumbBase === srcBase) {
        setActiveThumb(thumb);
      }
    });
  }

  /* ── Touch Swipe auf Hauptbild ────────────────────────────── */
  function bindSwipe() {
    if (!mainImgEl) return;
    var thumbBtns = thumbsEl
      ? Array.from(thumbsEl.querySelectorAll('.hoa-pdp__thumb'))
      : [];
    if (thumbBtns.length < 2) return;

    var startX = 0;
    var wrap = mainImgEl.parentNode;

    wrap.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    wrap.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 40) return;

      var activeIdx = thumbBtns.findIndex(function (t) {
        return t.classList.contains('hoa-pdp__thumb--active');
      });
      if (activeIdx === -1) activeIdx = 0;

      var nextIdx = dx < 0
        ? Math.min(thumbBtns.length - 1, activeIdx + 1)
        : Math.max(0, activeIdx - 1);

      thumbBtns[nextIdx].click();
    }, { passive: true });
  }

  /* ── Accordion ────────────────────────────────────────────── */
  function bindAccordion() {
    document.querySelectorAll('.hoa-pdp__acc-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        var item   = trigger.closest('.hoa-pdp__acc-item');

        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) {
          item.removeAttribute('data-acc-open');
        } else {
          item.setAttribute('data-acc-open', '');
        }
      });
    });
  }

  /* ── Sticky ATC (Mobile) ──────────────────────────────────── */
  function initStickyAtc() {
    if (!atcBtn || !stickyBar || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting;
        stickyBar.classList.toggle('hoa-pdp__sticky-atc--visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });

    observer.observe(atcBtn);
  }

  /* ── Start ────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
